<template>
  <p-create />
</template>

<script>
import Create from './../components/reports/CreateReport.vue';
export default {
  components: {
    'p-create': Create
  }
};
</script>
